import React, { useEffect, useState } from "react";

import PropTypes from "prop-types";
//import Loadspinner from "../../common/Loadspinner";
import * as images from "../../constants/Images";
//import CommonService from "../../services/CommonService";
import "./AddComment.css";
import Avatar from "react-avatar";
//import { socket } from "../../common/Socket";
import Loadspinner from "../Loadspinner";
import Encrypt from "../../services/Encryption";
import Decrypt from "../../services/Decryption";
import { analytics } from "../../firebase";
import { logEvent } from 'firebase/analytics'
import { APICall } from "../../helpers/API/APICalls";
import { createComment } from "../../constants/ApiEndpoints";
import CommonConstants from "../../constants/CommonConstants";
import { getFromEncLocalStorage } from "../../helpers/Utils/Utils";


function AddComment(props) {
  const [comment, setComment] = useState("");
  const [commented, showComment] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [creatorId, setCreator] = useState();
  const [mycomment, setMyComment] = useState("");
  const [dp, setDp] = useState("");
  const [empName, setName] = useState("");
  const handleChange = (e) => {
    setComment(e.target.value);
  };

  useEffect(() => getDetails(), []);

  const getDetails = async () => {
    let dp = await getFromEncLocalStorage("profile_pic");
    let firstName = await getFromEncLocalStorage("firstname");
    let lastName = await getFromEncLocalStorage("lastname");
    // let creator = await getFromEncLocalStorage("employeenumber");
    let name = firstName + " " + lastName;

    setDp(dp);
    setName(name);
    //setCreator(creator);
  };
  const addComment = async () => {
    setLoading(true);
    let id = props.id;
    // let commentData = {
    //   knowledge_id: id,
    //   comment: comment,
    //   //created_by_id: "23066139",
    //   created_by_id: props.creator,
    // };
    // let eData = JSON.stringify({ data: commentData, encryptionType: true });
    // let encryptedData = Encrypt(eData);
    // let newData = {
    //   data: encryptedData,
    // };

    showComment(true);

    const employeeNum = getFromEncLocalStorage("employeenumber");
    const fName = getFromEncLocalStorage("firstname");
    const lName = getFromEncLocalStorage("lastname");
    //const empdepName = getFromEncLocalStorage("empDeptName");
    //const nameofPosition = getFromEncLocalStorage("nameofposition");

    const commentData = {
      comment: comment,
      knowledge_id: id,
      created_by_id: props.creator,
      commenter_name: `${fName} ${lName}`,
      loggedin_userid: employeeNum,
    }

    const resp = await APICall(createComment, commentData);

    console.log("createComment resp : ", resp);

    if (!resp?.data?.IsSucessful) {
      showComment(false);
      alert(resp?.data?.status);
    } else {
      props.sendComment(resp?.data);
    }

    // window.socketObj.emit("createComment", newData);
    // window.socketObj.on("createCommentBroadcast", (encData) => {
    //   let data = JSON.parse(Decrypt(encData.data));
    //   if (!data.IsSucessful) {
    //     showComment(false);
    //     alert(data.status);
    //   } else {
    //     props.sendComment(data);
    //   }
    // });
    setMyComment(comment);
    setComment("");
    //logEvent(analytics(), 'comment')
    setLoading(false);
  };

  return (
    <div>
      <Loadspinner filename="AddComment.js" isLoading={loading} isMiddle="true" />
      {props.isDetail ? null : commented ? (
        <div className="display-col">
          <h6>Comments</h6>
          <div className="display-row" style={{ marginTop: "10px" }}>
            {dp ? (
              <img src={dp} alt="Profile pic" className="comment-dp-img" />
            ) : (
              <Avatar
                name={empName}
                size="30px"
                round={true}
                style={{ marginRight: "10px" }}
              />
            )}

            <p>{mycomment}</p>
          </div>
          <hr />
        </div>
      ) : null}
      <div className="display-row" style={{ alignItems: "center" }}>
        {dp ? (
          <img src={dp} alt="Profile pic" className="comment-dp-img" />
        ) : (
          <Avatar name={empName} size="30px" round={true} />
        )}
        <input
          type="text"
          className="form-control comment-input"
          placeholder="Your Comment"
          onChange={handleChange}
          value={comment}
          autoComplete={CommonConstants.autoCompleteInput}
        />
        <img
          src={images.send}
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title="Add"
          className="send-img"
          onClick={addComment}
        />
      </div>
    </div>
  );
}

export default AddComment;

AddComment.propTypes = {
  id: PropTypes.number,
  sendComment: PropTypes.func,
  isDetail: PropTypes.bool,
  creator: PropTypes.string,
};
